/**
 * SLA ProgressBar with over-100% breach support (P07 fix D).
 * When percent > 100: full red bar at 100% width + protruding chip showing overage.
 * Tooltip on breach: "Đã vượt quá thời hạn SLA. Ticket cần xử lý ngay."
 */

interface SlaProgressBarProps {
    percent: number
    isBreached: boolean
}

const SlaProgressBar = ({ percent, isBreached }: SlaProgressBarProps) => {
    const isOver = percent > 100
    const displayWidth = Math.min(percent, 100)
    const bgColor =
        isBreached || isOver
            ? 'bg-red-500'
            : percent >= 80
              ? 'bg-orange-500'
              : 'bg-green-500'

    return (
        <div className="space-y-1">
            <div
                className="w-full bg-gray-200 rounded-full h-2 overflow-hidden"
                title={
                    isOver
                        ? 'Đã vượt quá thời hạn SLA. Ticket cần xử lý ngay.'
                        : undefined
                }
            >
                <div
                    className={`h-full ${bgColor} transition-all duration-300`}
                    style={{ width: `${displayWidth}%` }}
                />
            </div>
            <div className="flex items-center gap-1">
                <span
                    className={`text-xs font-medium ${
                        isBreached || isOver
                            ? 'text-red-600'
                            : 'text-orange-600'
                    }`}
                >
                    {Math.round(percent)}%
                </span>
                {isOver && (
                    <span className="text-xs font-semibold bg-red-100 text-red-700 px-1 rounded">
                        vượt {Math.round(percent - 100)}%
                    </span>
                )}
            </div>
        </div>
    )
}

export default SlaProgressBar
